<template>
<div class="kpt-subexport-context-pane">
    <header class="kpt-context-pane-header">
      <h4><strong>Monthly Subscription Report</strong></h4>
      <b-icon icon="times-circle" @click.native="close"></b-icon>
    </header>
    <main class="kpt-context-pane-main">
      <b-field label="Select Month">
        <b-datepicker
          inline
          v-model="selectedMonth"
          type="month"
          icon="calendar"
          trap-focus>
        </b-datepicker>
      </b-field>
      <p v-if="selectedMonth" style="margin-bottom: 8px">Report month selected: {{format(selectedMonth, 'MM/yyyy')}}.</p>
      <b-button :disabled="selectedMonth == null || fetchingReport" :loading="fetchingReport" icon-left="download" type="is-primary" @click="getReport">Get Report</b-button>
    </main>
    <footer class="kpt-context-pane-footer"></footer>
  </div>
</template>
<script>
import { format } from 'date-fns';
import download from 'downloadjs';

export default {
  data() {
    return {
      selectedMonth: null,
      format,
      fetchingReport: false
    }
  },
  methods: {
    async getReport() {
      this.fetchingReport = true;
      const blob = await this.$store.dispatch('fetchSubscriptionReport', this.selectedMonth); 
      if (blob?.size <= 0) {
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Failed to fetch monthly subscription report, Please try again later.',
          type: 'is-danger'
        });
        this.fetchingReport = false;
        return false;
      }
      const selectedMonthAndYear = this.selectedMonth;
      download(blob, `UsageReport-${selectedMonthAndYear.getUTCFullYear()}-${selectedMonthAndYear.getUTCMonth() + 1}.xlsx`, 'application/vnd.ms-excel');
      this.fetchingReport = false;
      return true;
    }
  },
  props: {
    close: Function
  }
}
</script>
<style lang="scss" scoped>
.kpt-subexport-context-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
